import React from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import type { PromotedEntities, TournamentsMenuLayerItem } from '../../types';
import {
  MENU_ITEM_TYPE,
} from 'app/modules/Navigation/types';

import { createMenuItemTestDataAttributesGetter } from '../../test-data-helpers';
import { isSelectedMenuItem } from '../../utils';
import { MenuItem } from '../MenuItem';
import { LinkContent } from './LinkContent';

import styles from './TournamentsMenu.module.scss';

const getMenuItemTestDataAttributes = createMenuItemTestDataAttributesGetter(
  'layer-menu-item',
  MENU_ITEM_TYPE.TOURNAMENT,
);

type TournamentMenuItemProps = {
  entry: TournamentsMenuLayerItem;
  promotedEntities: PromotedEntities;
  promotedEntityId?: string;
  className?: string;
};

export const TournamentsMenuItem: React.FC<TournamentMenuItemProps> = ({
  entry,
  promotedEntities,
  promotedEntityId,
}) => {
  const { pathname } = useLocation();
  const testDataAttributes = getMenuItemTestDataAttributes(entry);
  const isSelectedTournament = isSelectedMenuItem(entry, pathname);

  const linkClassNames = classNames(
    styles.link,
    {
      [styles.linkSelected]: isSelectedTournament,
    },
  );

  return (
    <MenuItem entry={entry}
              promotedEntities={promotedEntities}
              promotedEntityId={promotedEntityId}
              testDataAttributes={testDataAttributes}
              to={entry.location}
              classNameItem={styles.item}
              classNameLink={linkClassNames} >
      <LinkContent caption={entry.caption}
                   label={entry.label} />
    </MenuItem>
  );
};
